import { TableState } from '../types'

export const createDefaultState = (): TableState => ({
  columnOrder: [],
  columnHidden: {},
  columnWidths: {},
  columnPinned: {},
  sorts: [],
  filters: [],
  pivot: undefined,
  pagination: { page: 0, pageSize: 25 }
})
